// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h3, h2, h4 {
  color: #000;
  font-weight: normal;
  font-family: Capture, sans-serif;
  font-size: 24px;
}

a {
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/impressum/impressum.page.scss"],"names":[],"mappings":"AAAC;EACI,WAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;AACL;;AAEC;EACE,WAAA;AACH","sourcesContent":[" h3,h2,h4 {\n     color: #000;\n     font-weight: normal;\n     font-family: Capture, sans-serif;\n     font-size: 24px;\n }\n\n a {\n   color: #000;\n }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
